import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PrintAwareMixin extends Vue {
  get isInPrintMode(): boolean {
    return this.$route.name === 'project-print';
  }
}
